<template>
    <div class="pop_up_layer" style="display: block" @click="closeModal"></div>
    <div class="pop_up flex_box" style="display: block">
        <div class="pop_tit _flex">
            <p>{{ state.userName }} 회원 실적</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>
        <div class="sch_condition_wrap">
            <div class="left">
                <div class="select_tab_box _200">
                    <div class="selected_tab" @click="state.showTab = !state.showTab">
                        <span>{{ state.nameTab }}</span>
                    </div>
                    <div class="tab_option" :class="[state.showTab ? 'show' : '']">
                        <button type="button" @click.passive="changeTab(1)">성매매 의심업소 제보</button>
                        <button type="button" @click="changeTab(2)">성매매 알선광고 제보</button>
                        <button type="button" @click="changeTab(3)">반성매매 시민활동</button>
                        <button type="button" @click="changeTab(4)">캠페인·이벤트</button>
                    </div>
                </div>
            </div>
            <div class="right info_box">
                <div>
                    총
                    <span class="col_blue">{{ CommonUtils.numberFormat(state.totalLength) }}건</span>
                </div>
            </div>
        </div>
        <div class="common_table custom_scroll">
            <table>
                <colgroup>
                    <col style="width: 80px" />
                    <col />
                    <col style="width: 170px" />
                    <col style="width: 80px" />
                    <col style="width: 80px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>번호</th>
                        <th>제목</th>
                        <th>신청일</th>
                        <th>상태</th>
                        <th>선발여부</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-if="state.list.length > 0">
                        <tr v-for="(item, idx) in state.list" :key="item.idx">
                            <td>{{ (state.page - 1) * state.size + (idx + 1) }}</td>
                            <td>{{ item.boardVO.title }}</td>
                            <td>{{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}</td>
                            <td>{{ getBoardStateText(item.boardVO.state) }}</td>
                            <td>{{ getApplyStateText(item.state) }}</td>
                        </tr>
                    </template>
                    <tr v-else>
                        <td colspan="5">
                            <div class="tb_subject" style="text-align: center; width: 100%">실적이 없습니다.</div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <PageBtn
            v-if="state.list.length !== 0"
            :currentPage="state.page"
            :totalLength="state.totalLength"
            :perPage="state.size"
            @onPaging="handlePageChange"
        ></PageBtn>
    </div>
</template>
<script lang="ts">
    import { onMounted, reactive, watch, onUnmounted, CommonUtils, apiService, types, getMessageByCode, PageBtn } from "@/BaseComponent";

    export default {
        props: {
            idx: {
                type: Number,
                default: 0,
            },
            userName: {
                type: String,
                default: "",
            },
            tab: {
                type: Number,
                default: 0,
            },
        },
        components: {
            PageBtn,
        },
        emits: ["close", "changeTab"],
        setup(props: any, { emit }: any) {
            const state = reactive({
                idx: 0 as number,
                tab: 0 as number,
                userName: "" as string,

                data: {} as any,
                showTab: false as boolean,
                nameTab: "성매매 의심업소 제보" as string,

                list: [] as Array<any>,
                page: 1 as number,
                size: 20 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,
            });

            onMounted(() => {
                state.idx = props.idx;
                state.userName = props.userName;
                state.tab = props.tab;

                switch (state.tab) {
                    case 1:
                        state.nameTab = "성매매 의심업소 제보";
                        break;
                    case 2:
                        state.nameTab = "성매매 알선광고 제보";
                        break;
                    case 3:
                        state.nameTab = "반성매매 시민활동";
                        break;
                    case 4:
                        state.nameTab = "캠페인·이벤트";
                        break;
                }

                getList();
            });

            onUnmounted(() => {});

            const closeModal = () => {
                emit("close");
            };

            const changeTab = (tab: number) => {
                emit("changeTab", tab);
            };

            const getList = async () => {
                const param = {
                    idx: state.idx,
                    page: state.page,
                    size: state.size,
                    searchType: "",
                    searchText: "",
                };

                const res = await apiService.member.eventForPerformance(param);

                if (res.returnCode === 0) {
                    state.list = res.list.data;
                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                }
            };

            const handlePageChange = (page: number) => {
                state.page = page;
                getList();
            };

            const getBoardStateText = (param: number) => {
                switch (param) {
                    case 1:
                        return "대기중";
                    case 2:
                        return "진행중";
                    default:
                        return "진행종료";
                }
            };

            const getApplyStateText = (param: number) => {
                switch (param) {
                    case 1:
                        return "신청";
                    case 2:
                        return "선발";
                    default:
                        return "임시저장";
                }
            };

            return { state, closeModal, props, CommonUtils, changeTab, handlePageChange, getBoardStateText, getApplyStateText };
        },
    };
</script>

<style scoped>
    .tab_option.show {
        visibility: visible;
        height: auto;
        opacity: 1;
    }
</style>
